var _templateObject = _taggedTemplateLiteralLoose(['\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  0% {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  z-index: 2100;\n  opacity: 0;\n  background-color: rgba(0,0,0,0.6);\n  position: fixed;\n  top: 0vh;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition:all 0.3s ease-in-out;\n  .a-modal-container {\n  opacity: 0;\n  }\n  &.a-modal-open {\n  z-index: 9999;\n  animation: ', ' 0.3s normal forwards ease-in-out 0.1s;\n  .a-modal-container {\n  animation: ', ' 0.3s normal forwards ease-in-out 0.3s;\n  }\n  }\n'], ['\n  z-index: 2100;\n  opacity: 0;\n  background-color: rgba(0,0,0,0.6);\n  position: fixed;\n  top: 0vh;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition:all 0.3s ease-in-out;\n  .a-modal-container {\n  opacity: 0;\n  }\n  &.a-modal-open {\n  z-index: 9999;\n  animation: ', ' 0.3s normal forwards ease-in-out 0.1s;\n  .a-modal-container {\n  animation: ', ' 0.3s normal forwards ease-in-out 0.3s;\n  }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  width: 500px;\n  max-width: 100vw;\n  box-shadow: 0px 15px 10px -15px;\n  border-radius: ', ';\n  padding: ', ';\n  margin: ', ';\n  label{\n    width:100%;\n    text-align:center;\n    font-weight: 500;\n  }\n'], ['\n  background-color: ', ';\n  width: 500px;\n  max-width: 100vw;\n  box-shadow: 0px 15px 10px -15px;\n  border-radius: ', ';\n  padding: ', ';\n  margin: ', ';\n  label{\n    width:100%;\n    text-align:center;\n    font-weight: 500;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  margin-bottom: ', ';\n'], ['\n  text-align: left;\n  margin-bottom: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  float: right;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  width: 20px;\n  height: 20px;\n'], ['\n  float: right;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  width: 20px;\n  height: 20px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { keyframes, withTheme } from 'styled-components'; //import close from './close.svg';

import { wrapAssetPath } from '../../../utils';
var close = React.createElement('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 60 60'
}, React.createElement('g', {
  id: 'X',
  fill: 'none',
  stroke: '#2f3946',
  strokeWidth: '10',
  transform: 'translate(5 5)',
  strokeMiterlimit: '10',
  strokeLinecap: 'round'
}, React.createElement('line', {
  id: '_x5C_',
  x1: '5',
  y1: '5',
  x2: '50',
  y2: '50'
}), React.createElement('line', {
  id: '_x2F_',
  x1: '5',
  y1: '50',
  x2: '50',
  y2: '5'
})), React.createElement('g', {
  id: 'circle'
}, React.createElement('circle', {
  id: 'XMLID_16_',
  opacity: '0',
  fill: 'none',
  strokeWidth: '3',
  stroke: '#000',
  strokeMiterlimit: '10',
  cx: '30',
  cy: '30',
  r: '40'
})));

var fadeIn = function fadeIn(props) {
  return keyframes(_templateObject);
};

var slideUp = function slideUp(props) {
  return keyframes(_templateObject2);
};

var Overlay = styled.div(_templateObject3, fadeIn, slideUp);
var ModalContainer = styled.div(_templateObject4, function (props) {
  return props.theme.colours.neutral.lightest;
}, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.spaces.bitLoose;
}, function (props) {
  return props.theme.spaces.base;
});
var ModalTitle = styled.h4(_templateObject5, function (props) {
  return props.theme.spaces.base;
});
var ModalClose = styled.button(_templateObject6);

var Modal = function Modal(_ref) {
  var handleClose = _ref.handleClose,
      show = _ref.show,
      title = _ref.title,
      children = _ref.children,
      theme = _ref.theme;
  var showHideClassName = show ? "a-modal a-modal-open" : "a-modal a-modal-close";

  if (!show) {
    return null;
  }

  return React.createElement('div', {
    className: showHideClassName
  }, React.createElement(Overlay, {
    className: showHideClassName
  }, React.createElement(ModalContainer, {
    className: 'a-modal-container'
  }, handleClose && React.createElement(ModalClose, {
    onClick: handleClose
  }, close), title && React.createElement(ModalTitle, null, title), children)));
};

export default withTheme(Modal);